import React, { Component } from 'react';
import Helmet from 'react-helmet';
import RoundedButton from 'components/RoundedButton';

const CSS = require('./ErrorBoundary.less');

class ErrorBoundary extends Component<{}, { hasError: boolean }> {
  state = {
    hasError: false
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error);
  }

  render() {
    if (this.state.hasError) {
      const onReload = () => window?.location?.reload();
      const onBack = () => window?.history?.back();
      return (
        <>
          <Helmet>
            <meta name="render:status_code" content="500" />
          </Helmet>
          <div className={CSS.Error}>
            <h1 className={CSS.ErrorTitle}>Something went wrong</h1>
            <RoundedButton onClick={onReload}>Retry</RoundedButton>
            <button onClick={onBack} className={CSS.BackLink}>
              Go back
            </button>
          </div>
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
